import { CircularProgress, Stack } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

const LoaderPage = (props) => {
  const { label = "" } = props;

  return (
    <Stack
      spacing={4}
      sx={{
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100vh",
      }}
    >
      <CircularProgress />
      <p className="fr-h4">{label}</p>
    </Stack>
  );
};

LoaderPage.propTypes = {
  label: PropTypes.string,
};

export default LoaderPage;
